// eslint-disable-next-line no-shadow
export enum ClassList {
  Mounted = 'mounted',
  InView = 'in-view',
  Active = 'active',
  ForceToScroll = 'force-to-scroll',
  ScrollDown = 'scroll-down',
  BlueBackground = 'blue-background'
}
